export const replaceAt = (arr, index, value) =>
  arr.with
    ? arr.with(index, value)
    : [...arr.slice(0, index), value, ...arr.slice(index + 1)];
export const removeAt = (arr, index) =>
  arr.toSpliced
    ? arr.toSpliced(index, 1)
    : [...arr.slice(0, index), ...arr.slice(index + 1)];

export function buildIncludesString(...includes) {
  return Array.from(new Set(includes)).join(',');
}
